// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3TmN4","optimisation_btns":"styles_optimisation_btns__3Dsst","button":"styles_button__cBshs","button_body":"styles_button_body__3DvZg"};